module.exports = __webpack_public_path__ + "static/media/close_insta_android.433dbba8.svg";